export default "__VITE_ASSET__4bdfc595__"